import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";

export function useQueryState<T extends string | number>(
  key: string,
  defaultValue: T
): [T, (val: T) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawValue = searchParams.get(key);

  let value: T = defaultValue;
  if (rawValue !== null) {
    if (typeof defaultValue === "number") {
      const parsed = parseInt(rawValue, 10);
      value = (isNaN(parsed) ? defaultValue : parsed) as T;
    } else {
      value = rawValue as T;
    }
  }

  const setValue = useCallback(
    (newValue: T) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (newValue === defaultValue || newValue === null || newValue === undefined) {
            next.delete(key);
          } else {
            next.set(key, String(newValue));
          }
          return next;
        },
        { replace: true }
      );
    },
    [key, defaultValue, setSearchParams]
  );

  return [value, setValue];
}
